module.exports = __webpack_public_path__ + "4601faf7d92684e10f97e343cfc55549.pdf";